/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
// import { assets } from '03CommonApiParts/Configuration';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
const SdivMessageInputError = styled.div`	//項目入力エラー
	/* height: 12px; */
	margin: 0px 0px 0px 4px;
	padding: 0px;
	color: red;
	font-size: 10px;
  white-space:nowrap;
`;

/* How To Use 
  <InputErrorMessage errorMessage={error[payload]?.[item.id]?.message}/>
/> */

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const InputErrorMessage = (props) => {

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    const { errorMessage, style } = props;
    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/  
    return (
        <SdivMessageInputError style={style} >{typeof errorMessage === 'undefined' ? '': errorMessage}</SdivMessageInputError>
    );
};
